import React, { useEffect, useRef, useState } from "react";
import "./Counter.scss";
import CountUp from "react-countup";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";

const Counter = (props) => {
  const { counter } = props;
  const lang = useSelector((state) => state.locale.lang);
  const counterSec = useRef();
  const [startCount,setStartCount] = useState(false);

  const observ =()=>{
    let observer;
    let options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.35,
		};
    const callback = (entries)=>{
      if(entries[0].isIntersecting){
        setStartCount(true);
      } else {
        setStartCount(false)
      }
    }
		observer = new IntersectionObserver(callback, options);
    observer.observe(counterSec.current);
  }

  useEffect(()=>{
    observ()
  },[])
  return (
    <div className="counter">
      <div className="container py-5">
        <div className="counter__title text-center" ref={counterSec}>
          <h2 className=" m-auto text-white bold_font">
            {lang === "ar"
              ? "سحابة توظيف تجمع كل المستخدمين المذهلين"
              : "A SINGLE RECRUITMENT CLOUD THAT GATHERS ALL THE INCREDIBLE USERS"}
          </h2>
          <div className="counter__content row mt-4 mx-auto ">
            <div className="counter__content-item col-xl-3 col-sm-6 mt-2">
              <div className="inner d-flex flex-xl-column flex-sm-row align-items-center justify-content-xl-center mt-md-3">
                <h2 className="bold_font mb-0 mb-lg-3">
                  +{
                    startCount && 
                    <CountUp
                      end={counter.total_active_companies}
                      duration={1.5}
                      separator=","
                      useEasing
                      scrollSpyOnce={true}
                    />
                  }
                  </h2>
                <p className="semi_bold_font">{lang === "ar" ? "الشركات النشطة" : "Active Clients"}</p>
              </div>
            </div>
            <div className="counter__content-item  col-xl-3 col-sm-6 mt-2">
              <div className="inner d-flex flex-xl-column flex-row align-items-center justify-content-xl-center mt-md-3">
                <h2 className="bold_font mb-0 mb-lg-3">
                +{
                  startCount && 
                    <CountUp
                      end={counter.total_candidates}
                      duration={1.5}
                      separator=","
                      useEasing
                      scrollSpyOnce={true}
                    />
                  }
                  </h2>
                <p className="semi_bold_font">{lang === "ar" ? "المرشحين للوظائف" : "Candidates"}</p>
              </div>
            </div>
            <div className="counter__content-item  col-xl-3 col-sm-6 mt-2">
              <div className="inner d-flex flex-xl-column flex-row align-items-center justify-content-xl-center mt-md-3">
                <h2 className="bold_font mb-0 mb-lg-3">
                  +{
                  startCount && 
                    <CountUp
                      end={counter.total_interviews}
                      duration={1.5}
                      separator=","
                      useEasing
                      scrollSpyOnce={true}
                    />
                  }
                  </h2>
                <p className="semi_bold_font">{lang === "ar" ? "المقابلات المتعددة" : "Interviews"}</p>
              </div>
            </div>
            <div className="counter__content-item  col-xl-3 col-sm-6 mt-2">
              <div className="inner d-flex flex-xl-column flex-row align-items-center justify-content-xl-center mt-md-3">
                <h2 className="bold_font mb-0 mb-lg-3">
                +{
                  startCount && 
                    <CountUp
                      end={counter.total_offers}
                      duration={1.5}
                      separator=","
                      useEasing
                      scrollSpyOnce={true}
                    />
                  }
                  </h2>
                <p className="semi_bold_font">{lang === "ar" ? " العروض الوظيفية" : "Offers"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default injectIntl(Counter);
